import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";

class Error extends Component {
  render() {
    const { settings, loading } = this.props.appData;
    let publicUrl = process.env.PUBLIC_URL + "/";
    let bgClassic = publicUrl + "assets/img/banner/errorbg.jpeg";
    return (
      <div
        className="ltn__coming-soon-area section-bg-2 text-color-white bg-overlay-theme-black-90 bg-image"
        data-bs-bg={bgClassic}
      >
        <div className="container">
          <div className="row">
            <Link to="/">
              {!loading && settings?.logo && (
                <img src={API_FILE_URL + settings.logo} alt="Logo" />
              )}
            </Link>
          </div>
          <div className="row mt-150">
            <div className="col-lg-12">
              <div className="error-404-inner text-center">
                <div className="error-img mb-30">
                  <img
                    src={publicUrl + "assets/img/others/error-1.png"}
                    alt="#"
                    style={{
                      maxWidth: "70%",
                    }}
                  />
                </div>
                <h1 className="error-404-title d-none">404</h1>
                <h2>Sayfa Bulunamadı!</h2>
                {/* <h3>Oops! Looks like something going rong</h3> */}
                <p>
                  Aradığınız sayfa mevcut değil, taşınmış veya silinmiş
                  olabilir. Ana sayfaya dönerek yolculuğunuza kaldığınız yerden
                  devam edebilirsiniz.
                </p>
                <div className="btn-wrapper go-top">
                  {/* Ana buton */}
                  <div className="btn-wrapper">
                    <Link to="/" className="btn-premium">
                      <i className="fas fa-home" />
                      Ana Sayfaya Dön
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppData(Error);
